/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from "react";

const elBgImage = require("./res/images/wallpaper.jpg");

interface WallpaperProps {
  containerStyle?: object;
  imageStyle?: object;
  imgURL?: string;
}

const styles = {
  container: {
    position: "fixed",
    left: 0,
    top: 0,
    width: "100%",
    height: "100%",
    pointerEvents: "none",
  },
  image: {
    position: "absolute",
    left: "0px",
    right: "0px",
    top: "0px",
    width: "100%",
    height: "100%",
    opacity: 0.2,
  },
};

export const Wallpaper = (props: WallpaperProps) => {
  const { containerStyle, imageStyle, imgURL } = props;
  return (
    <div style={{ ...styles?.container, ...containerStyle }}>
      <div
        style={{
          ...styles?.image,
          ...imageStyle,
          backgroundImage: "url(" + imgURL + ")",
        }}
      />
    </div>
  );
};

const style_elBgImage = {
  backgroundImage: "url(" + elBgImage + ")",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "50% 50%",
  backgroundSize: "cover",
};

Wallpaper.defaultProps = {
  imageStyle: style_elBgImage,
  imgURL: elBgImage,
};
